import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UzytkownikService } from '../../../@core/http/uzytkownik.service';
import { KodyBledowApiService } from '../../../@core/services/kody-bledow-api.service';
import { BladApi } from '../../../shared/models/kody-bledow-api.model';

@Component({
  selector: 'ngx-zmiana-hasla',
  templateUrl: './zmiana-hasla.component.html',
  styleUrls: ['./zmiana-hasla.component.scss'],
})
export class ZmianaHaslaComponent implements OnInit, OnDestroy {

  form: FormGroup;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private readonly fb: FormBuilder,
    private readonly kodyBledowService: KodyBledowApiService,
    private readonly router: Router,
    private readonly toastrService: NbToastrService,
    private readonly translate: TranslateService,
    private readonly uzytkownikService: UzytkownikService,

  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      poprzednieHaslo: ['', [Validators.required, Validators.minLength(6)]],
      noweHaslo: ['', Validators.minLength(6)],
      powtorzoneHaslo: ['', RxwebValidators.compare({fieldName: 'noweHaslo' })],
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  wyslij() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }

    this.uzytkownikService.zmienHaslo(this.form.value)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        () => {
          this.toastrService.show('', this.translate.instant('komunikat.haslo-zmienione'), { status: 'success' });
          this.router.navigateByUrl('');
        },
        blad => this.wyswietlKomunikatyBledu(blad),
      );
  }

  wyswietlKomunikatyBledu(response: HttpErrorResponse) {
    const kodBledu: BladApi = this.kodyBledowService.get(response);
    if (kodBledu === BladApi.NIEPRAWIDLOWE_HASLO) {
      this.form.controls.poprzednieHaslo.setErrors({incorrectPassword: true});
    } else if (kodBledu === BladApi.HASLA_ROZNIA_SIE) {
      this.form.controls.powtorzoneHaslo.setErrors({compare: true});
    } else {
      this.toastrService.show('', this.translate.instant('komunikat.nieznany-blad'), { status: 'danger' });
    }
  }

  get f() { return this.form.controls; }
}
